import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const ROLES = ["booker", "restaurant", "admin"];

export default function AdminUsers() {
  const [list, setList] = useState([]);
  const [roleFilter, setRoleFilter] = useState("all");
  const [rests, setRests] = useState([]);

  const load = async () => {
    const params = roleFilter === "all" ? {} : { role: roleFilter };
    const { data } = await api.get("/admin/users", { params });
    setList(data);
  };
  const loadRests = async () => {
    const { data } = await api.get("/admin/restaurants");
    setRests(data);
  };
  useEffect(() => { load(); }, [roleFilter]); // eslint-disable-line
  useEffect(() => { loadRests(); }, []);

  const patchUser = async (uid, body) => {
    try { await api.patch(`/admin/users/${uid}`, body); toast.success("Updated"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-5 animate-fade-up">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">Users</p>
          <h1 className="font-serif text-4xl">All users</h1>
        </div>
        <div className="w-48">
          <Select value={roleFilter} onValueChange={setRoleFilter}>
            <SelectTrigger data-testid="users-role-filter"><SelectValue/></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All roles</SelectItem>
              {ROLES.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </header>

      <div className="tablo-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-cream">
            <tr className="text-xs uppercase tracking-wider text-light-ink">
              <th className="text-left p-3">Phone</th>
              <th className="text-left p-3">Name</th>
              <th className="text-left p-3">Org</th>
              <th className="text-left p-3">Role</th>
              <th className="text-left p-3">Restaurant</th>
              <th className="text-left p-3">Approver</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && (<tr><td colSpan={6} className="p-6 text-center text-light-ink">No users.</td></tr>)}
            {list.map((u) => (
              <tr key={u.id} className="border-t border-tablo-border hover:bg-off-white" data-testid={`user-row-${u.id}`}>
                <td className="p-3 font-mono text-xs">{u.phone}</td>
                <td className="p-3">{u.name || <span className="text-light-ink/60">—</span>}</td>
                <td className="p-3 text-xs">{u.org_name || <span className="text-light-ink/60">—</span>}</td>
                <td className="p-3">
                  <Select value={u.role} onValueChange={(v) => patchUser(u.id, { role: v })}>
                    <SelectTrigger className="w-28 h-8 text-xs" data-testid={`user-role-${u.id}`}><SelectValue/></SelectTrigger>
                    <SelectContent>{ROLES.map((r) => <SelectItem key={r} value={r} className="text-xs">{r}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
                <td className="p-3">
                  <Select value={u.restaurant?.id || "none"} onValueChange={(v) => patchUser(u.id, { restaurant_id: v === "none" ? null : v })}>
                    <SelectTrigger className="w-44 h-8 text-xs" data-testid={`user-rest-${u.id}`}><SelectValue placeholder="—"/></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none" className="text-xs">— none —</SelectItem>
                      {rests.map((r) => <SelectItem key={r.id} value={r.id} className="text-xs">{r.name}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
                <td className="p-3"><Switch checked={!!u.is_approver} onCheckedChange={(v) => patchUser(u.id, { is_approver: v })} data-testid={`user-approver-${u.id}`}/></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
